import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableDirectModeCarriers = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableDirectModeCarriers);
};
